<template>
  <div
    class="jb-sidebar-filters"
    :class="{ 'in-modal': vModal }"
  >
    <div class="jb-sidebar-filters-wrap">
      <h2 class="jb-sidebar-header jb-first-sidebar-header bg-ghost-gray">
        Minimum education required
      </h2>
      <div
        v-for="filter in jobEducationFilters"
        :key="filter.label"
        class="checkbox-wrap"
      >
        <input
          :id="filter.label"
          type="checkbox"
          :value="filter.matchValue"
          :checked="isFilterChecked(filter.matchValue, 'jobeducation')"
          @change="updateFilters('jobeducation', $event)"
        >
        <label :for="filter.label"><div>{{ filter.label }}</div></label>
      </div>
      <!-- <h2 class="jb-sidebar-header bg-ghost-gray">
        Filter by Position Type
      </h2>
      <div
        v-for="filter in jobTypeFilters"
        :key="filter.label"
        class="checkbox-wrap"
      >
        <input
          :id="filter.label"
          type="checkbox"
          :value="filter.matchValue"
          :checked="isFilterChecked(filter.matchValue, 'jobtype')"
          @change="updateFilters('jobtype', $event)"
        >
        <label :for="filter.label"><div>{{ filter.label }}</div></label>
      </div> -->
      <h2 class="jb-sidebar-header bg-ghost-gray">
        Filter by Contract
      </h2>
      <div
        v-for="filter in jobOtherFilters"
        :key="filter.label"
        class="checkbox-wrap"
      >
        <input
          :id="filter.label"
          type="checkbox"
          :value="filter.matchValue"
          :checked="isFilterChecked(filter.matchValue, 'jobother')"
          @change="updateFilters('jobother', $event)"
        >
        <label :for="filter.label"><div>{{ filter.label }}</div></label>
      </div>
      <h2 class="jb-sidebar-header bg-ghost-gray">
        Filter by Competition
      </h2>
      <div
        v-for="filter in jobCompetitionFilters"
        :key="filter.label"
        class="checkbox-wrap"
      >
        <input
          :id="filter.label"
          :ref="`checkbox-${filter.matchValue}`"
          type="checkbox"
          :value="filter.matchValue"
          :checked="isFilterChecked(filter.matchValue, 'jobcompt')"
          @change="updateFilters('jobcompt', $event)"
        >
        <label :for="filter.label"><div>{{ filter.label }}</div></label>
      </div>
      <div
        v-if="vModal"
        class="v-modal-btns"
      >
        <input
          class="jb-apply-filters-btn button"
          type="button"
          value="Apply Filters"
          @click="$modal.hide('job-filters')"
        >
        <input
          class="jb-clear-all-btn button"
          type="button"
          :disabled="!hasFilters"
          value="Clear All Filters"
          @click="clearAllFilters(); $modal.hide('job-filters')"
        >
      </div>
    </div>
    <div
      v-if="!vModal"
    >
      <input
        class="jb-clear-all-btn button"
        type="button"
        :disabled="!hasFilters"
        value="Clear All Filters"
        @click="clearAllFilters()"
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    jobTypeFilters: {
      type: Array,
      default: () => {
        return [];
      },
    },
    jobOtherFilters: {
      type: Array,
      default: () => {
        return [];
      },
    }, 
    jobCompetitionFilters: {
      type: Array,
      default: () => {
        return [];
      },
    },
    jobEducationFilters: {
      type: Array,
      default: () => {
        return [];
      },
    },
    jobtype: {
      type: Array,
      default: () => {
        return [];
      },
    },
    jobcompt: {
      type: Array,
      default: () => {
        return [];
      },
    },
    jobother: {
      type: Array,
      default: () => {
        return [];
      },
    },
    jobeducation: {
      type: Array,
      default: () => {
        return [];
      },
    },
    updateResultsList: {
      type: Function,
      default: () => {
        return;
      },
    },
    clearAllFilters: {
      type: Function,
      default: () => {
        return;
      },
    },
    hasFilters: {
      type: Boolean,
      default: false,
    },
    vModal: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    /**
    * @desc is checkbox checked
    * @param { String } value
    * @param { String } filter name to eval
    * @returns { Boolean }
    */
    isFilterChecked (value, filter) {
      if (this[filter].includes(value)) {
        return true;
      }
      return false;
    },

    /**
    * @desc emits filter updates back to parent
    * @param { String } filter name to eval
    * @param { Object } $event object
    */
    updateFilters (filter, e) {
      let newFilters = this[filter];
      if (e.target.checked) {
        if (!this[filter].includes(e.target.value)) {
          newFilters.push(e.target.value);
        }
      } else {
        newFilters = this[filter].filter(item => item !== e.target.value);
      }
      this.$emit(`update:${filter}`, newFilters);
      this.updateResultsList();
    },
  },
};
</script>
